import * as React from 'react';

import { Badge } from 'common/components';
import { useGetPriorities } from 'security-app/hooks/useInvestigationsAPI';
import type { PriorityAPIType } from 'security-app/hooks/api/investigationsAPI.types';
type BadgeColor = 'danger' | 'warning' | 'default';

const badgeColorByPriority = (p: number, threshold: number): BadgeColor => {
  if (p >= threshold) return 'danger';
  if (p === threshold - 1) return 'warning';

  return 'default';
};

type Props = {
  priorityValue: number;
};

function PriorityCell({ priorityValue }: Props) {
  const { priorities } = useGetPriorities(true);

  const [critical, high] = React.useMemo(
    () => [priorities?.[priorities.length - 1], priorities?.[priorities.length - 2]],
    [priorities],
  );

  const priorityText = React.useMemo(
    () => priorities.find((priority: PriorityAPIType) => priority.priority === priorityValue)?.text || null,
    [priorities, priorityValue],
  );

  return (
    <Badge
      size="sm"
      variant={badgeColorByPriority(priorityValue, high?.priority)}
      solid={priorityValue === critical?.priority}>
      {priorityText}
    </Badge>
  );
}

export default PriorityCell;
